import React, {Component} from 'react';
import {Helmet} from "react-helmet";
import 'css/markdown-styles.css'
import {config} from 'config'
import TrimmisFrontpage from "../components/TrimmisFrontpage";
import BookTime from "../components/booking/BookTime";

import { addLocaleData, IntlProvider } from 'react-intl';

import fiLocale from 'react-intl/locale-data/fi';
import seLocale from 'react-intl/locale-data/se';
import noLocale from 'react-intl/locale-data/no';

import fiTranslations from '../resources/strings/fi_FI.json';
import seTranslations from '../resources/strings/se_SE.json';
import noTranslations from '../resources/strings/no_NO.json';


export default class YamlWrapper extends Component {
    constructor() {
        super();
        this.components = {
            frontPage: TrimmisFrontpage,
            bookTime: BookTime
        };
        this.i18n = {
            translations: {
                fi: fiTranslations,
                se: seTranslations,
                no: noTranslations
            },
            titles: {
                fi: "Trimmis FI",
                se: "Trimmis SE",
                no: "Trimmis NO"
            },
            canonicals: {
                fi: "mustijamirri/trimmis",
                se: "arkenzoo.se/trimmis",
                no: "musti.no/trimmis"
            }
        };
        addLocaleData(fiLocale);
        addLocaleData(seLocale);
        addLocaleData(noLocale);
    }
    render() {
        const data = this.props.route.page.data;
        const Component = this.components[data.layout];
        return (
            <div>
                <Helmet>
                    <meta charSet="utf-8" />
                    <title>{this.i18n.titles[data.brand]}</title>
                    <link rel="canonical" href={this.i18n.canonicals[data.brand]}/>
                </Helmet>
                <IntlProvider locale={data.brand} messages={this.i18n.translations[data.brand]}>
                    <Component brand={data.brand}/>
                </IntlProvider>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ../wrappers/yaml.js